import React, { useState } from 'react';
import { X } from 'lucide-react';
export function StickyBanner() {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-navy-dark via-navy to-navy-dark text-ice py-3 px-4 shadow-lg border-b border-gold/30" data-id="element-246">
      <div className="max-w-5xl mx-auto flex items-center justify-center gap-3 relative" data-id="element-247">
        <span className="text-gold text-lg" data-id="element-248">✦</span>
        <p className="font-body text-sm md:text-base text-center text-ice/90" data-id="element-249">
          <span className="text-gold font-bold" data-id="element-250">
            No es casualidad que hayas entrado aquí...
          </span>{' '}
          Lee atentamente si necesitas protección
        </p>
        <span className="text-gold text-lg" data-id="element-251">✦</span>
        <button onClick={() => setVisible(false)} className="absolute right-0 text-ice/50 hover:text-ice transition-colors" aria-label="Cerrar banner" data-id="element-252">
          <X className="w-4 h-4" data-id="element-253" />
        </button>
      </div>
    </div>;
}